var map = {
	"./af-NA/numbers.json": [
		"./node_modules/cldr-data/main/af-NA/numbers.json",
		41
	],
	"./af/numbers.json": [
		"./node_modules/cldr-data/main/af/numbers.json",
		46
	],
	"./am/numbers.json": [
		"./node_modules/cldr-data/main/am/numbers.json",
		51
	],
	"./ar-AE/numbers.json": [
		"./node_modules/cldr-data/main/ar-AE/numbers.json",
		56
	],
	"./ar-BH/numbers.json": [
		"./node_modules/cldr-data/main/ar-BH/numbers.json",
		61
	],
	"./ar-DJ/numbers.json": [
		"./node_modules/cldr-data/main/ar-DJ/numbers.json",
		66
	],
	"./ar-DZ/numbers.json": [
		"./node_modules/cldr-data/main/ar-DZ/numbers.json",
		71
	],
	"./ar-EG/numbers.json": [
		"./node_modules/cldr-data/main/ar-EG/numbers.json",
		76
	],
	"./ar-EH/numbers.json": [
		"./node_modules/cldr-data/main/ar-EH/numbers.json",
		81
	],
	"./ar-ER/numbers.json": [
		"./node_modules/cldr-data/main/ar-ER/numbers.json",
		86
	],
	"./ar-IL/numbers.json": [
		"./node_modules/cldr-data/main/ar-IL/numbers.json",
		91
	],
	"./ar-IQ/numbers.json": [
		"./node_modules/cldr-data/main/ar-IQ/numbers.json",
		96
	],
	"./ar-JO/numbers.json": [
		"./node_modules/cldr-data/main/ar-JO/numbers.json",
		101
	],
	"./ar-KM/numbers.json": [
		"./node_modules/cldr-data/main/ar-KM/numbers.json",
		106
	],
	"./ar-KW/numbers.json": [
		"./node_modules/cldr-data/main/ar-KW/numbers.json",
		111
	],
	"./ar-LB/numbers.json": [
		"./node_modules/cldr-data/main/ar-LB/numbers.json",
		116
	],
	"./ar-LY/numbers.json": [
		"./node_modules/cldr-data/main/ar-LY/numbers.json",
		121
	],
	"./ar-MA/numbers.json": [
		"./node_modules/cldr-data/main/ar-MA/numbers.json",
		126
	],
	"./ar-MR/numbers.json": [
		"./node_modules/cldr-data/main/ar-MR/numbers.json",
		131
	],
	"./ar-OM/numbers.json": [
		"./node_modules/cldr-data/main/ar-OM/numbers.json",
		136
	],
	"./ar-PS/numbers.json": [
		"./node_modules/cldr-data/main/ar-PS/numbers.json",
		141
	],
	"./ar-QA/numbers.json": [
		"./node_modules/cldr-data/main/ar-QA/numbers.json",
		146
	],
	"./ar-SA/numbers.json": [
		"./node_modules/cldr-data/main/ar-SA/numbers.json",
		151
	],
	"./ar-SD/numbers.json": [
		"./node_modules/cldr-data/main/ar-SD/numbers.json",
		156
	],
	"./ar-SO/numbers.json": [
		"./node_modules/cldr-data/main/ar-SO/numbers.json",
		161
	],
	"./ar-SS/numbers.json": [
		"./node_modules/cldr-data/main/ar-SS/numbers.json",
		166
	],
	"./ar-SY/numbers.json": [
		"./node_modules/cldr-data/main/ar-SY/numbers.json",
		171
	],
	"./ar-TD/numbers.json": [
		"./node_modules/cldr-data/main/ar-TD/numbers.json",
		176
	],
	"./ar-TN/numbers.json": [
		"./node_modules/cldr-data/main/ar-TN/numbers.json",
		181
	],
	"./ar-YE/numbers.json": [
		"./node_modules/cldr-data/main/ar-YE/numbers.json",
		186
	],
	"./ar/numbers.json": [
		"./node_modules/cldr-data/main/ar/numbers.json",
		191
	],
	"./as/numbers.json": [
		"./node_modules/cldr-data/main/as/numbers.json",
		196
	],
	"./az-Latn/numbers.json": [
		"./node_modules/cldr-data/main/az-Latn/numbers.json",
		201
	],
	"./az/numbers.json": [
		"./node_modules/cldr-data/main/az/numbers.json",
		206
	],
	"./be/numbers.json": [
		"./node_modules/cldr-data/main/be/numbers.json",
		211
	],
	"./bg/numbers.json": [
		"./node_modules/cldr-data/main/bg/numbers.json",
		216
	],
	"./bn-IN/numbers.json": [
		"./node_modules/cldr-data/main/bn-IN/numbers.json",
		221
	],
	"./bn/numbers.json": [
		"./node_modules/cldr-data/main/bn/numbers.json",
		226
	],
	"./bs-Latn/numbers.json": [
		"./node_modules/cldr-data/main/bs-Latn/numbers.json",
		231
	],
	"./bs/numbers.json": [
		"./node_modules/cldr-data/main/bs/numbers.json",
		236
	],
	"./ca-AD/numbers.json": [
		"./node_modules/cldr-data/main/ca-AD/numbers.json",
		241
	],
	"./ca-ES-VALENCIA/numbers.json": [
		"./node_modules/cldr-data/main/ca-ES-VALENCIA/numbers.json",
		246
	],
	"./ca-FR/numbers.json": [
		"./node_modules/cldr-data/main/ca-FR/numbers.json",
		251
	],
	"./ca-IT/numbers.json": [
		"./node_modules/cldr-data/main/ca-IT/numbers.json",
		256
	],
	"./ca/numbers.json": [
		"./node_modules/cldr-data/main/ca/numbers.json",
		261
	],
	"./cs/numbers.json": [
		"./node_modules/cldr-data/main/cs/numbers.json",
		266
	],
	"./cy/numbers.json": [
		"./node_modules/cldr-data/main/cy/numbers.json",
		271
	],
	"./da-GL/numbers.json": [
		"./node_modules/cldr-data/main/da-GL/numbers.json",
		276
	],
	"./da/numbers.json": [
		"./node_modules/cldr-data/main/da/numbers.json",
		281
	],
	"./de-AT/numbers.json": [
		"./node_modules/cldr-data/main/de-AT/numbers.json",
		286
	],
	"./de-BE/numbers.json": [
		"./node_modules/cldr-data/main/de-BE/numbers.json",
		291
	],
	"./de-CH/numbers.json": [
		"./node_modules/cldr-data/main/de-CH/numbers.json",
		296
	],
	"./de-IT/numbers.json": [
		"./node_modules/cldr-data/main/de-IT/numbers.json",
		301
	],
	"./de-LI/numbers.json": [
		"./node_modules/cldr-data/main/de-LI/numbers.json",
		306
	],
	"./de-LU/numbers.json": [
		"./node_modules/cldr-data/main/de-LU/numbers.json",
		311
	],
	"./de/numbers.json": [
		"./node_modules/cldr-data/main/de/numbers.json",
		316
	],
	"./el-CY/numbers.json": [
		"./node_modules/cldr-data/main/el-CY/numbers.json",
		321
	],
	"./el/numbers.json": [
		"./node_modules/cldr-data/main/el/numbers.json",
		326
	],
	"./en-001/numbers.json": [
		"./node_modules/cldr-data/main/en-001/numbers.json",
		331
	],
	"./en-150/numbers.json": [
		"./node_modules/cldr-data/main/en-150/numbers.json",
		336
	],
	"./en-AE/numbers.json": [
		"./node_modules/cldr-data/main/en-AE/numbers.json",
		341
	],
	"./en-AG/numbers.json": [
		"./node_modules/cldr-data/main/en-AG/numbers.json",
		346
	],
	"./en-AI/numbers.json": [
		"./node_modules/cldr-data/main/en-AI/numbers.json",
		351
	],
	"./en-AS/numbers.json": [
		"./node_modules/cldr-data/main/en-AS/numbers.json",
		356
	],
	"./en-AT/numbers.json": [
		"./node_modules/cldr-data/main/en-AT/numbers.json",
		361
	],
	"./en-AU/numbers.json": [
		"./node_modules/cldr-data/main/en-AU/numbers.json",
		366
	],
	"./en-BB/numbers.json": [
		"./node_modules/cldr-data/main/en-BB/numbers.json",
		371
	],
	"./en-BE/numbers.json": [
		"./node_modules/cldr-data/main/en-BE/numbers.json",
		376
	],
	"./en-BI/numbers.json": [
		"./node_modules/cldr-data/main/en-BI/numbers.json",
		381
	],
	"./en-BM/numbers.json": [
		"./node_modules/cldr-data/main/en-BM/numbers.json",
		386
	],
	"./en-BS/numbers.json": [
		"./node_modules/cldr-data/main/en-BS/numbers.json",
		391
	],
	"./en-BW/numbers.json": [
		"./node_modules/cldr-data/main/en-BW/numbers.json",
		396
	],
	"./en-BZ/numbers.json": [
		"./node_modules/cldr-data/main/en-BZ/numbers.json",
		401
	],
	"./en-CA/numbers.json": [
		"./node_modules/cldr-data/main/en-CA/numbers.json",
		406
	],
	"./en-CC/numbers.json": [
		"./node_modules/cldr-data/main/en-CC/numbers.json",
		411
	],
	"./en-CH/numbers.json": [
		"./node_modules/cldr-data/main/en-CH/numbers.json",
		416
	],
	"./en-CK/numbers.json": [
		"./node_modules/cldr-data/main/en-CK/numbers.json",
		421
	],
	"./en-CM/numbers.json": [
		"./node_modules/cldr-data/main/en-CM/numbers.json",
		426
	],
	"./en-CX/numbers.json": [
		"./node_modules/cldr-data/main/en-CX/numbers.json",
		431
	],
	"./en-CY/numbers.json": [
		"./node_modules/cldr-data/main/en-CY/numbers.json",
		436
	],
	"./en-DE/numbers.json": [
		"./node_modules/cldr-data/main/en-DE/numbers.json",
		441
	],
	"./en-DG/numbers.json": [
		"./node_modules/cldr-data/main/en-DG/numbers.json",
		446
	],
	"./en-DK/numbers.json": [
		"./node_modules/cldr-data/main/en-DK/numbers.json",
		451
	],
	"./en-DM/numbers.json": [
		"./node_modules/cldr-data/main/en-DM/numbers.json",
		456
	],
	"./en-ER/numbers.json": [
		"./node_modules/cldr-data/main/en-ER/numbers.json",
		461
	],
	"./en-FI/numbers.json": [
		"./node_modules/cldr-data/main/en-FI/numbers.json",
		466
	],
	"./en-FJ/numbers.json": [
		"./node_modules/cldr-data/main/en-FJ/numbers.json",
		471
	],
	"./en-FK/numbers.json": [
		"./node_modules/cldr-data/main/en-FK/numbers.json",
		476
	],
	"./en-FM/numbers.json": [
		"./node_modules/cldr-data/main/en-FM/numbers.json",
		481
	],
	"./en-GB/numbers.json": [
		"./node_modules/cldr-data/main/en-GB/numbers.json",
		486
	],
	"./en-GD/numbers.json": [
		"./node_modules/cldr-data/main/en-GD/numbers.json",
		491
	],
	"./en-GG/numbers.json": [
		"./node_modules/cldr-data/main/en-GG/numbers.json",
		496
	],
	"./en-GH/numbers.json": [
		"./node_modules/cldr-data/main/en-GH/numbers.json",
		501
	],
	"./en-GI/numbers.json": [
		"./node_modules/cldr-data/main/en-GI/numbers.json",
		506
	],
	"./en-GM/numbers.json": [
		"./node_modules/cldr-data/main/en-GM/numbers.json",
		511
	],
	"./en-GU/numbers.json": [
		"./node_modules/cldr-data/main/en-GU/numbers.json",
		516
	],
	"./en-GY/numbers.json": [
		"./node_modules/cldr-data/main/en-GY/numbers.json",
		521
	],
	"./en-HK/numbers.json": [
		"./node_modules/cldr-data/main/en-HK/numbers.json",
		526
	],
	"./en-IE/numbers.json": [
		"./node_modules/cldr-data/main/en-IE/numbers.json",
		531
	],
	"./en-IL/numbers.json": [
		"./node_modules/cldr-data/main/en-IL/numbers.json",
		536
	],
	"./en-IM/numbers.json": [
		"./node_modules/cldr-data/main/en-IM/numbers.json",
		541
	],
	"./en-IN/numbers.json": [
		"./node_modules/cldr-data/main/en-IN/numbers.json",
		546
	],
	"./en-IO/numbers.json": [
		"./node_modules/cldr-data/main/en-IO/numbers.json",
		551
	],
	"./en-JE/numbers.json": [
		"./node_modules/cldr-data/main/en-JE/numbers.json",
		556
	],
	"./en-JM/numbers.json": [
		"./node_modules/cldr-data/main/en-JM/numbers.json",
		561
	],
	"./en-KE/numbers.json": [
		"./node_modules/cldr-data/main/en-KE/numbers.json",
		566
	],
	"./en-KI/numbers.json": [
		"./node_modules/cldr-data/main/en-KI/numbers.json",
		571
	],
	"./en-KN/numbers.json": [
		"./node_modules/cldr-data/main/en-KN/numbers.json",
		576
	],
	"./en-KY/numbers.json": [
		"./node_modules/cldr-data/main/en-KY/numbers.json",
		581
	],
	"./en-LC/numbers.json": [
		"./node_modules/cldr-data/main/en-LC/numbers.json",
		586
	],
	"./en-LR/numbers.json": [
		"./node_modules/cldr-data/main/en-LR/numbers.json",
		591
	],
	"./en-LS/numbers.json": [
		"./node_modules/cldr-data/main/en-LS/numbers.json",
		596
	],
	"./en-MG/numbers.json": [
		"./node_modules/cldr-data/main/en-MG/numbers.json",
		601
	],
	"./en-MH/numbers.json": [
		"./node_modules/cldr-data/main/en-MH/numbers.json",
		606
	],
	"./en-MO/numbers.json": [
		"./node_modules/cldr-data/main/en-MO/numbers.json",
		611
	],
	"./en-MP/numbers.json": [
		"./node_modules/cldr-data/main/en-MP/numbers.json",
		616
	],
	"./en-MS/numbers.json": [
		"./node_modules/cldr-data/main/en-MS/numbers.json",
		621
	],
	"./en-MT/numbers.json": [
		"./node_modules/cldr-data/main/en-MT/numbers.json",
		626
	],
	"./en-MU/numbers.json": [
		"./node_modules/cldr-data/main/en-MU/numbers.json",
		631
	],
	"./en-MW/numbers.json": [
		"./node_modules/cldr-data/main/en-MW/numbers.json",
		636
	],
	"./en-MY/numbers.json": [
		"./node_modules/cldr-data/main/en-MY/numbers.json",
		641
	],
	"./en-NA/numbers.json": [
		"./node_modules/cldr-data/main/en-NA/numbers.json",
		646
	],
	"./en-NF/numbers.json": [
		"./node_modules/cldr-data/main/en-NF/numbers.json",
		651
	],
	"./en-NG/numbers.json": [
		"./node_modules/cldr-data/main/en-NG/numbers.json",
		656
	],
	"./en-NL/numbers.json": [
		"./node_modules/cldr-data/main/en-NL/numbers.json",
		661
	],
	"./en-NR/numbers.json": [
		"./node_modules/cldr-data/main/en-NR/numbers.json",
		666
	],
	"./en-NU/numbers.json": [
		"./node_modules/cldr-data/main/en-NU/numbers.json",
		671
	],
	"./en-NZ/numbers.json": [
		"./node_modules/cldr-data/main/en-NZ/numbers.json",
		676
	],
	"./en-PG/numbers.json": [
		"./node_modules/cldr-data/main/en-PG/numbers.json",
		681
	],
	"./en-PH/numbers.json": [
		"./node_modules/cldr-data/main/en-PH/numbers.json",
		686
	],
	"./en-PK/numbers.json": [
		"./node_modules/cldr-data/main/en-PK/numbers.json",
		691
	],
	"./en-PN/numbers.json": [
		"./node_modules/cldr-data/main/en-PN/numbers.json",
		696
	],
	"./en-PR/numbers.json": [
		"./node_modules/cldr-data/main/en-PR/numbers.json",
		701
	],
	"./en-PW/numbers.json": [
		"./node_modules/cldr-data/main/en-PW/numbers.json",
		706
	],
	"./en-RW/numbers.json": [
		"./node_modules/cldr-data/main/en-RW/numbers.json",
		711
	],
	"./en-SB/numbers.json": [
		"./node_modules/cldr-data/main/en-SB/numbers.json",
		716
	],
	"./en-SC/numbers.json": [
		"./node_modules/cldr-data/main/en-SC/numbers.json",
		721
	],
	"./en-SD/numbers.json": [
		"./node_modules/cldr-data/main/en-SD/numbers.json",
		726
	],
	"./en-SE/numbers.json": [
		"./node_modules/cldr-data/main/en-SE/numbers.json",
		731
	],
	"./en-SG/numbers.json": [
		"./node_modules/cldr-data/main/en-SG/numbers.json",
		736
	],
	"./en-SH/numbers.json": [
		"./node_modules/cldr-data/main/en-SH/numbers.json",
		741
	],
	"./en-SI/numbers.json": [
		"./node_modules/cldr-data/main/en-SI/numbers.json",
		746
	],
	"./en-SL/numbers.json": [
		"./node_modules/cldr-data/main/en-SL/numbers.json",
		751
	],
	"./en-SS/numbers.json": [
		"./node_modules/cldr-data/main/en-SS/numbers.json",
		756
	],
	"./en-SX/numbers.json": [
		"./node_modules/cldr-data/main/en-SX/numbers.json",
		761
	],
	"./en-SZ/numbers.json": [
		"./node_modules/cldr-data/main/en-SZ/numbers.json",
		766
	],
	"./en-TC/numbers.json": [
		"./node_modules/cldr-data/main/en-TC/numbers.json",
		771
	],
	"./en-TK/numbers.json": [
		"./node_modules/cldr-data/main/en-TK/numbers.json",
		776
	],
	"./en-TO/numbers.json": [
		"./node_modules/cldr-data/main/en-TO/numbers.json",
		781
	],
	"./en-TT/numbers.json": [
		"./node_modules/cldr-data/main/en-TT/numbers.json",
		786
	],
	"./en-TV/numbers.json": [
		"./node_modules/cldr-data/main/en-TV/numbers.json",
		791
	],
	"./en-TZ/numbers.json": [
		"./node_modules/cldr-data/main/en-TZ/numbers.json",
		796
	],
	"./en-UG/numbers.json": [
		"./node_modules/cldr-data/main/en-UG/numbers.json",
		801
	],
	"./en-UM/numbers.json": [
		"./node_modules/cldr-data/main/en-UM/numbers.json",
		806
	],
	"./en-US-POSIX/numbers.json": [
		"./node_modules/cldr-data/main/en-US-POSIX/numbers.json",
		811
	],
	"./en-VC/numbers.json": [
		"./node_modules/cldr-data/main/en-VC/numbers.json",
		816
	],
	"./en-VG/numbers.json": [
		"./node_modules/cldr-data/main/en-VG/numbers.json",
		821
	],
	"./en-VI/numbers.json": [
		"./node_modules/cldr-data/main/en-VI/numbers.json",
		826
	],
	"./en-VU/numbers.json": [
		"./node_modules/cldr-data/main/en-VU/numbers.json",
		831
	],
	"./en-WS/numbers.json": [
		"./node_modules/cldr-data/main/en-WS/numbers.json",
		836
	],
	"./en-ZA/numbers.json": [
		"./node_modules/cldr-data/main/en-ZA/numbers.json",
		841
	],
	"./en-ZM/numbers.json": [
		"./node_modules/cldr-data/main/en-ZM/numbers.json",
		846
	],
	"./en-ZW/numbers.json": [
		"./node_modules/cldr-data/main/en-ZW/numbers.json",
		851
	],
	"./en/numbers.json": [
		"./node_modules/cldr-data/main/en/numbers.json",
		856
	],
	"./es-419/numbers.json": [
		"./node_modules/cldr-data/main/es-419/numbers.json",
		861
	],
	"./es-AR/numbers.json": [
		"./node_modules/cldr-data/main/es-AR/numbers.json",
		866
	],
	"./es-BO/numbers.json": [
		"./node_modules/cldr-data/main/es-BO/numbers.json",
		871
	],
	"./es-BR/numbers.json": [
		"./node_modules/cldr-data/main/es-BR/numbers.json",
		876
	],
	"./es-BZ/numbers.json": [
		"./node_modules/cldr-data/main/es-BZ/numbers.json",
		881
	],
	"./es-CL/numbers.json": [
		"./node_modules/cldr-data/main/es-CL/numbers.json",
		886
	],
	"./es-CO/numbers.json": [
		"./node_modules/cldr-data/main/es-CO/numbers.json",
		891
	],
	"./es-CR/numbers.json": [
		"./node_modules/cldr-data/main/es-CR/numbers.json",
		896
	],
	"./es-CU/numbers.json": [
		"./node_modules/cldr-data/main/es-CU/numbers.json",
		901
	],
	"./es-DO/numbers.json": [
		"./node_modules/cldr-data/main/es-DO/numbers.json",
		906
	],
	"./es-EA/numbers.json": [
		"./node_modules/cldr-data/main/es-EA/numbers.json",
		911
	],
	"./es-EC/numbers.json": [
		"./node_modules/cldr-data/main/es-EC/numbers.json",
		916
	],
	"./es-GQ/numbers.json": [
		"./node_modules/cldr-data/main/es-GQ/numbers.json",
		921
	],
	"./es-GT/numbers.json": [
		"./node_modules/cldr-data/main/es-GT/numbers.json",
		926
	],
	"./es-HN/numbers.json": [
		"./node_modules/cldr-data/main/es-HN/numbers.json",
		931
	],
	"./es-IC/numbers.json": [
		"./node_modules/cldr-data/main/es-IC/numbers.json",
		936
	],
	"./es-MX/numbers.json": [
		"./node_modules/cldr-data/main/es-MX/numbers.json",
		941
	],
	"./es-NI/numbers.json": [
		"./node_modules/cldr-data/main/es-NI/numbers.json",
		946
	],
	"./es-PA/numbers.json": [
		"./node_modules/cldr-data/main/es-PA/numbers.json",
		951
	],
	"./es-PE/numbers.json": [
		"./node_modules/cldr-data/main/es-PE/numbers.json",
		956
	],
	"./es-PH/numbers.json": [
		"./node_modules/cldr-data/main/es-PH/numbers.json",
		961
	],
	"./es-PR/numbers.json": [
		"./node_modules/cldr-data/main/es-PR/numbers.json",
		966
	],
	"./es-PY/numbers.json": [
		"./node_modules/cldr-data/main/es-PY/numbers.json",
		971
	],
	"./es-SV/numbers.json": [
		"./node_modules/cldr-data/main/es-SV/numbers.json",
		976
	],
	"./es-US/numbers.json": [
		"./node_modules/cldr-data/main/es-US/numbers.json",
		981
	],
	"./es-UY/numbers.json": [
		"./node_modules/cldr-data/main/es-UY/numbers.json",
		986
	],
	"./es-VE/numbers.json": [
		"./node_modules/cldr-data/main/es-VE/numbers.json",
		991
	],
	"./es/numbers.json": [
		"./node_modules/cldr-data/main/es/numbers.json",
		996
	],
	"./et/numbers.json": [
		"./node_modules/cldr-data/main/et/numbers.json",
		1001
	],
	"./eu/numbers.json": [
		"./node_modules/cldr-data/main/eu/numbers.json",
		1006
	],
	"./fa-AF/numbers.json": [
		"./node_modules/cldr-data/main/fa-AF/numbers.json",
		1011
	],
	"./fa/numbers.json": [
		"./node_modules/cldr-data/main/fa/numbers.json",
		1016
	],
	"./fi/numbers.json": [
		"./node_modules/cldr-data/main/fi/numbers.json",
		1021
	],
	"./fil/numbers.json": [
		"./node_modules/cldr-data/main/fil/numbers.json",
		1026
	],
	"./fr-BE/numbers.json": [
		"./node_modules/cldr-data/main/fr-BE/numbers.json",
		1031
	],
	"./fr-BF/numbers.json": [
		"./node_modules/cldr-data/main/fr-BF/numbers.json",
		1036
	],
	"./fr-BI/numbers.json": [
		"./node_modules/cldr-data/main/fr-BI/numbers.json",
		1041
	],
	"./fr-BJ/numbers.json": [
		"./node_modules/cldr-data/main/fr-BJ/numbers.json",
		1046
	],
	"./fr-BL/numbers.json": [
		"./node_modules/cldr-data/main/fr-BL/numbers.json",
		1051
	],
	"./fr-CA/numbers.json": [
		"./node_modules/cldr-data/main/fr-CA/numbers.json",
		1056
	],
	"./fr-CD/numbers.json": [
		"./node_modules/cldr-data/main/fr-CD/numbers.json",
		1061
	],
	"./fr-CF/numbers.json": [
		"./node_modules/cldr-data/main/fr-CF/numbers.json",
		1066
	],
	"./fr-CG/numbers.json": [
		"./node_modules/cldr-data/main/fr-CG/numbers.json",
		1071
	],
	"./fr-CH/numbers.json": [
		"./node_modules/cldr-data/main/fr-CH/numbers.json",
		1076
	],
	"./fr-CI/numbers.json": [
		"./node_modules/cldr-data/main/fr-CI/numbers.json",
		1081
	],
	"./fr-CM/numbers.json": [
		"./node_modules/cldr-data/main/fr-CM/numbers.json",
		1086
	],
	"./fr-DJ/numbers.json": [
		"./node_modules/cldr-data/main/fr-DJ/numbers.json",
		1091
	],
	"./fr-DZ/numbers.json": [
		"./node_modules/cldr-data/main/fr-DZ/numbers.json",
		1096
	],
	"./fr-GA/numbers.json": [
		"./node_modules/cldr-data/main/fr-GA/numbers.json",
		1101
	],
	"./fr-GF/numbers.json": [
		"./node_modules/cldr-data/main/fr-GF/numbers.json",
		1106
	],
	"./fr-GN/numbers.json": [
		"./node_modules/cldr-data/main/fr-GN/numbers.json",
		1111
	],
	"./fr-GP/numbers.json": [
		"./node_modules/cldr-data/main/fr-GP/numbers.json",
		1116
	],
	"./fr-GQ/numbers.json": [
		"./node_modules/cldr-data/main/fr-GQ/numbers.json",
		1121
	],
	"./fr-HT/numbers.json": [
		"./node_modules/cldr-data/main/fr-HT/numbers.json",
		1126
	],
	"./fr-KM/numbers.json": [
		"./node_modules/cldr-data/main/fr-KM/numbers.json",
		1131
	],
	"./fr-LU/numbers.json": [
		"./node_modules/cldr-data/main/fr-LU/numbers.json",
		1136
	],
	"./fr-MA/numbers.json": [
		"./node_modules/cldr-data/main/fr-MA/numbers.json",
		1141
	],
	"./fr-MC/numbers.json": [
		"./node_modules/cldr-data/main/fr-MC/numbers.json",
		1146
	],
	"./fr-MF/numbers.json": [
		"./node_modules/cldr-data/main/fr-MF/numbers.json",
		1151
	],
	"./fr-MG/numbers.json": [
		"./node_modules/cldr-data/main/fr-MG/numbers.json",
		1156
	],
	"./fr-ML/numbers.json": [
		"./node_modules/cldr-data/main/fr-ML/numbers.json",
		1161
	],
	"./fr-MQ/numbers.json": [
		"./node_modules/cldr-data/main/fr-MQ/numbers.json",
		1166
	],
	"./fr-MR/numbers.json": [
		"./node_modules/cldr-data/main/fr-MR/numbers.json",
		1171
	],
	"./fr-MU/numbers.json": [
		"./node_modules/cldr-data/main/fr-MU/numbers.json",
		1176
	],
	"./fr-NC/numbers.json": [
		"./node_modules/cldr-data/main/fr-NC/numbers.json",
		1181
	],
	"./fr-NE/numbers.json": [
		"./node_modules/cldr-data/main/fr-NE/numbers.json",
		1186
	],
	"./fr-PF/numbers.json": [
		"./node_modules/cldr-data/main/fr-PF/numbers.json",
		1191
	],
	"./fr-PM/numbers.json": [
		"./node_modules/cldr-data/main/fr-PM/numbers.json",
		1196
	],
	"./fr-RE/numbers.json": [
		"./node_modules/cldr-data/main/fr-RE/numbers.json",
		1201
	],
	"./fr-RW/numbers.json": [
		"./node_modules/cldr-data/main/fr-RW/numbers.json",
		1206
	],
	"./fr-SC/numbers.json": [
		"./node_modules/cldr-data/main/fr-SC/numbers.json",
		1211
	],
	"./fr-SN/numbers.json": [
		"./node_modules/cldr-data/main/fr-SN/numbers.json",
		1216
	],
	"./fr-SY/numbers.json": [
		"./node_modules/cldr-data/main/fr-SY/numbers.json",
		1221
	],
	"./fr-TD/numbers.json": [
		"./node_modules/cldr-data/main/fr-TD/numbers.json",
		1226
	],
	"./fr-TG/numbers.json": [
		"./node_modules/cldr-data/main/fr-TG/numbers.json",
		1231
	],
	"./fr-TN/numbers.json": [
		"./node_modules/cldr-data/main/fr-TN/numbers.json",
		1236
	],
	"./fr-VU/numbers.json": [
		"./node_modules/cldr-data/main/fr-VU/numbers.json",
		1241
	],
	"./fr-WF/numbers.json": [
		"./node_modules/cldr-data/main/fr-WF/numbers.json",
		1246
	],
	"./fr-YT/numbers.json": [
		"./node_modules/cldr-data/main/fr-YT/numbers.json",
		1251
	],
	"./fr/numbers.json": [
		"./node_modules/cldr-data/main/fr/numbers.json",
		1256
	],
	"./ga-GB/numbers.json": [
		"./node_modules/cldr-data/main/ga-GB/numbers.json",
		1261
	],
	"./ga/numbers.json": [
		"./node_modules/cldr-data/main/ga/numbers.json",
		1266
	],
	"./gl/numbers.json": [
		"./node_modules/cldr-data/main/gl/numbers.json",
		1271
	],
	"./gu/numbers.json": [
		"./node_modules/cldr-data/main/gu/numbers.json",
		1276
	],
	"./he/numbers.json": [
		"./node_modules/cldr-data/main/he/numbers.json",
		1281
	],
	"./hi/numbers.json": [
		"./node_modules/cldr-data/main/hi/numbers.json",
		1286
	],
	"./hr-BA/numbers.json": [
		"./node_modules/cldr-data/main/hr-BA/numbers.json",
		1291
	],
	"./hr/numbers.json": [
		"./node_modules/cldr-data/main/hr/numbers.json",
		1296
	],
	"./hu/numbers.json": [
		"./node_modules/cldr-data/main/hu/numbers.json",
		1301
	],
	"./hy/numbers.json": [
		"./node_modules/cldr-data/main/hy/numbers.json",
		1306
	],
	"./id/numbers.json": [
		"./node_modules/cldr-data/main/id/numbers.json",
		1311
	],
	"./is/numbers.json": [
		"./node_modules/cldr-data/main/is/numbers.json",
		1316
	],
	"./it-CH/numbers.json": [
		"./node_modules/cldr-data/main/it-CH/numbers.json",
		1321
	],
	"./it-SM/numbers.json": [
		"./node_modules/cldr-data/main/it-SM/numbers.json",
		1326
	],
	"./it-VA/numbers.json": [
		"./node_modules/cldr-data/main/it-VA/numbers.json",
		1331
	],
	"./it/numbers.json": [
		"./node_modules/cldr-data/main/it/numbers.json",
		1336
	],
	"./ja/numbers.json": [
		"./node_modules/cldr-data/main/ja/numbers.json",
		1341
	],
	"./jv/numbers.json": [
		"./node_modules/cldr-data/main/jv/numbers.json",
		1346
	],
	"./ka/numbers.json": [
		"./node_modules/cldr-data/main/ka/numbers.json",
		1351
	],
	"./kk/numbers.json": [
		"./node_modules/cldr-data/main/kk/numbers.json",
		1356
	],
	"./km/numbers.json": [
		"./node_modules/cldr-data/main/km/numbers.json",
		1361
	],
	"./kn/numbers.json": [
		"./node_modules/cldr-data/main/kn/numbers.json",
		1366
	],
	"./ko-KP/numbers.json": [
		"./node_modules/cldr-data/main/ko-KP/numbers.json",
		1371
	],
	"./ko/numbers.json": [
		"./node_modules/cldr-data/main/ko/numbers.json",
		1376
	],
	"./ky/numbers.json": [
		"./node_modules/cldr-data/main/ky/numbers.json",
		1381
	],
	"./lo/numbers.json": [
		"./node_modules/cldr-data/main/lo/numbers.json",
		1386
	],
	"./lt/numbers.json": [
		"./node_modules/cldr-data/main/lt/numbers.json",
		1391
	],
	"./lv/numbers.json": [
		"./node_modules/cldr-data/main/lv/numbers.json",
		1396
	],
	"./mk/numbers.json": [
		"./node_modules/cldr-data/main/mk/numbers.json",
		1401
	],
	"./ml/numbers.json": [
		"./node_modules/cldr-data/main/ml/numbers.json",
		1406
	],
	"./mn/numbers.json": [
		"./node_modules/cldr-data/main/mn/numbers.json",
		1411
	],
	"./mr/numbers.json": [
		"./node_modules/cldr-data/main/mr/numbers.json",
		1416
	],
	"./ms-BN/numbers.json": [
		"./node_modules/cldr-data/main/ms-BN/numbers.json",
		1421
	],
	"./ms-SG/numbers.json": [
		"./node_modules/cldr-data/main/ms-SG/numbers.json",
		1426
	],
	"./ms/numbers.json": [
		"./node_modules/cldr-data/main/ms/numbers.json",
		1431
	],
	"./my/numbers.json": [
		"./node_modules/cldr-data/main/my/numbers.json",
		1436
	],
	"./nb-SJ/numbers.json": [
		"./node_modules/cldr-data/main/nb-SJ/numbers.json",
		1441
	],
	"./nb/numbers.json": [
		"./node_modules/cldr-data/main/nb/numbers.json",
		1446
	],
	"./ne-IN/numbers.json": [
		"./node_modules/cldr-data/main/ne-IN/numbers.json",
		1451
	],
	"./ne/numbers.json": [
		"./node_modules/cldr-data/main/ne/numbers.json",
		1456
	],
	"./nl-AW/numbers.json": [
		"./node_modules/cldr-data/main/nl-AW/numbers.json",
		1461
	],
	"./nl-BE/numbers.json": [
		"./node_modules/cldr-data/main/nl-BE/numbers.json",
		1466
	],
	"./nl-BQ/numbers.json": [
		"./node_modules/cldr-data/main/nl-BQ/numbers.json",
		1471
	],
	"./nl-CW/numbers.json": [
		"./node_modules/cldr-data/main/nl-CW/numbers.json",
		1476
	],
	"./nl-SR/numbers.json": [
		"./node_modules/cldr-data/main/nl-SR/numbers.json",
		1481
	],
	"./nl-SX/numbers.json": [
		"./node_modules/cldr-data/main/nl-SX/numbers.json",
		1486
	],
	"./nl/numbers.json": [
		"./node_modules/cldr-data/main/nl/numbers.json",
		1491
	],
	"./or/numbers.json": [
		"./node_modules/cldr-data/main/or/numbers.json",
		1496
	],
	"./pa-Guru/numbers.json": [
		"./node_modules/cldr-data/main/pa-Guru/numbers.json",
		1501
	],
	"./pa/numbers.json": [
		"./node_modules/cldr-data/main/pa/numbers.json",
		1506
	],
	"./pl/numbers.json": [
		"./node_modules/cldr-data/main/pl/numbers.json",
		1511
	],
	"./ps-PK/numbers.json": [
		"./node_modules/cldr-data/main/ps-PK/numbers.json",
		1516
	],
	"./ps/numbers.json": [
		"./node_modules/cldr-data/main/ps/numbers.json",
		1521
	],
	"./pt-AO/numbers.json": [
		"./node_modules/cldr-data/main/pt-AO/numbers.json",
		1526
	],
	"./pt-CH/numbers.json": [
		"./node_modules/cldr-data/main/pt-CH/numbers.json",
		1531
	],
	"./pt-CV/numbers.json": [
		"./node_modules/cldr-data/main/pt-CV/numbers.json",
		1536
	],
	"./pt-GQ/numbers.json": [
		"./node_modules/cldr-data/main/pt-GQ/numbers.json",
		1541
	],
	"./pt-GW/numbers.json": [
		"./node_modules/cldr-data/main/pt-GW/numbers.json",
		1546
	],
	"./pt-LU/numbers.json": [
		"./node_modules/cldr-data/main/pt-LU/numbers.json",
		1551
	],
	"./pt-MO/numbers.json": [
		"./node_modules/cldr-data/main/pt-MO/numbers.json",
		1556
	],
	"./pt-MZ/numbers.json": [
		"./node_modules/cldr-data/main/pt-MZ/numbers.json",
		1561
	],
	"./pt-PT/numbers.json": [
		"./node_modules/cldr-data/main/pt-PT/numbers.json",
		1566
	],
	"./pt-ST/numbers.json": [
		"./node_modules/cldr-data/main/pt-ST/numbers.json",
		1571
	],
	"./pt-TL/numbers.json": [
		"./node_modules/cldr-data/main/pt-TL/numbers.json",
		1576
	],
	"./pt/numbers.json": [
		"./node_modules/cldr-data/main/pt/numbers.json",
		1581
	],
	"./ro-MD/numbers.json": [
		"./node_modules/cldr-data/main/ro-MD/numbers.json",
		1586
	],
	"./ro/numbers.json": [
		"./node_modules/cldr-data/main/ro/numbers.json",
		1591
	],
	"./root/numbers.json": [
		"./node_modules/cldr-data/main/root/numbers.json",
		1596
	],
	"./ru-BY/numbers.json": [
		"./node_modules/cldr-data/main/ru-BY/numbers.json",
		1601
	],
	"./ru-KG/numbers.json": [
		"./node_modules/cldr-data/main/ru-KG/numbers.json",
		1606
	],
	"./ru-KZ/numbers.json": [
		"./node_modules/cldr-data/main/ru-KZ/numbers.json",
		1611
	],
	"./ru-MD/numbers.json": [
		"./node_modules/cldr-data/main/ru-MD/numbers.json",
		1616
	],
	"./ru-UA/numbers.json": [
		"./node_modules/cldr-data/main/ru-UA/numbers.json",
		1621
	],
	"./ru/numbers.json": [
		"./node_modules/cldr-data/main/ru/numbers.json",
		1626
	],
	"./sd/numbers.json": [
		"./node_modules/cldr-data/main/sd/numbers.json",
		1631
	],
	"./si/numbers.json": [
		"./node_modules/cldr-data/main/si/numbers.json",
		1636
	],
	"./sk/numbers.json": [
		"./node_modules/cldr-data/main/sk/numbers.json",
		1641
	],
	"./sl/numbers.json": [
		"./node_modules/cldr-data/main/sl/numbers.json",
		1646
	],
	"./so-DJ/numbers.json": [
		"./node_modules/cldr-data/main/so-DJ/numbers.json",
		1651
	],
	"./so-ET/numbers.json": [
		"./node_modules/cldr-data/main/so-ET/numbers.json",
		1656
	],
	"./so-KE/numbers.json": [
		"./node_modules/cldr-data/main/so-KE/numbers.json",
		1661
	],
	"./so/numbers.json": [
		"./node_modules/cldr-data/main/so/numbers.json",
		1666
	],
	"./sq-MK/numbers.json": [
		"./node_modules/cldr-data/main/sq-MK/numbers.json",
		1671
	],
	"./sq-XK/numbers.json": [
		"./node_modules/cldr-data/main/sq-XK/numbers.json",
		1676
	],
	"./sq/numbers.json": [
		"./node_modules/cldr-data/main/sq/numbers.json",
		1681
	],
	"./sr-Cyrl-BA/numbers.json": [
		"./node_modules/cldr-data/main/sr-Cyrl-BA/numbers.json",
		1686
	],
	"./sr-Cyrl-ME/numbers.json": [
		"./node_modules/cldr-data/main/sr-Cyrl-ME/numbers.json",
		1691
	],
	"./sr-Cyrl-XK/numbers.json": [
		"./node_modules/cldr-data/main/sr-Cyrl-XK/numbers.json",
		1696
	],
	"./sr-Cyrl/numbers.json": [
		"./node_modules/cldr-data/main/sr-Cyrl/numbers.json",
		1701
	],
	"./sr-Latn-BA/numbers.json": [
		"./node_modules/cldr-data/main/sr-Latn-BA/numbers.json",
		1706
	],
	"./sr-Latn-ME/numbers.json": [
		"./node_modules/cldr-data/main/sr-Latn-ME/numbers.json",
		1711
	],
	"./sr-Latn-XK/numbers.json": [
		"./node_modules/cldr-data/main/sr-Latn-XK/numbers.json",
		1716
	],
	"./sr-Latn/numbers.json": [
		"./node_modules/cldr-data/main/sr-Latn/numbers.json",
		1721
	],
	"./sr/numbers.json": [
		"./node_modules/cldr-data/main/sr/numbers.json",
		1726
	],
	"./sv-AX/numbers.json": [
		"./node_modules/cldr-data/main/sv-AX/numbers.json",
		1731
	],
	"./sv-FI/numbers.json": [
		"./node_modules/cldr-data/main/sv-FI/numbers.json",
		1736
	],
	"./sv/numbers.json": [
		"./node_modules/cldr-data/main/sv/numbers.json",
		1741
	],
	"./sw-CD/numbers.json": [
		"./node_modules/cldr-data/main/sw-CD/numbers.json",
		1746
	],
	"./sw-KE/numbers.json": [
		"./node_modules/cldr-data/main/sw-KE/numbers.json",
		1751
	],
	"./sw-UG/numbers.json": [
		"./node_modules/cldr-data/main/sw-UG/numbers.json",
		1756
	],
	"./sw/numbers.json": [
		"./node_modules/cldr-data/main/sw/numbers.json",
		1761
	],
	"./ta-LK/numbers.json": [
		"./node_modules/cldr-data/main/ta-LK/numbers.json",
		1766
	],
	"./ta-MY/numbers.json": [
		"./node_modules/cldr-data/main/ta-MY/numbers.json",
		1771
	],
	"./ta-SG/numbers.json": [
		"./node_modules/cldr-data/main/ta-SG/numbers.json",
		1776
	],
	"./ta/numbers.json": [
		"./node_modules/cldr-data/main/ta/numbers.json",
		1781
	],
	"./te/numbers.json": [
		"./node_modules/cldr-data/main/te/numbers.json",
		1786
	],
	"./th/numbers.json": [
		"./node_modules/cldr-data/main/th/numbers.json",
		1791
	],
	"./tk/numbers.json": [
		"./node_modules/cldr-data/main/tk/numbers.json",
		1796
	],
	"./tr-CY/numbers.json": [
		"./node_modules/cldr-data/main/tr-CY/numbers.json",
		1801
	],
	"./tr/numbers.json": [
		"./node_modules/cldr-data/main/tr/numbers.json",
		1806
	],
	"./uk/numbers.json": [
		"./node_modules/cldr-data/main/uk/numbers.json",
		1811
	],
	"./ur-IN/numbers.json": [
		"./node_modules/cldr-data/main/ur-IN/numbers.json",
		1816
	],
	"./ur/numbers.json": [
		"./node_modules/cldr-data/main/ur/numbers.json",
		1821
	],
	"./uz-Latn/numbers.json": [
		"./node_modules/cldr-data/main/uz-Latn/numbers.json",
		1826
	],
	"./uz/numbers.json": [
		"./node_modules/cldr-data/main/uz/numbers.json",
		1831
	],
	"./vi/numbers.json": [
		"./node_modules/cldr-data/main/vi/numbers.json",
		1836
	],
	"./yue-Hant/numbers.json": [
		"./node_modules/cldr-data/main/yue-Hant/numbers.json",
		1841
	],
	"./yue/numbers.json": [
		"./node_modules/cldr-data/main/yue/numbers.json",
		1846
	],
	"./zh-Hans-HK/numbers.json": [
		"./node_modules/cldr-data/main/zh-Hans-HK/numbers.json",
		1851
	],
	"./zh-Hans-MO/numbers.json": [
		"./node_modules/cldr-data/main/zh-Hans-MO/numbers.json",
		1856
	],
	"./zh-Hans-SG/numbers.json": [
		"./node_modules/cldr-data/main/zh-Hans-SG/numbers.json",
		1861
	],
	"./zh-Hans/numbers.json": [
		"./node_modules/cldr-data/main/zh-Hans/numbers.json",
		1866
	],
	"./zh-Hant-HK/numbers.json": [
		"./node_modules/cldr-data/main/zh-Hant-HK/numbers.json",
		1871
	],
	"./zh-Hant-MO/numbers.json": [
		"./node_modules/cldr-data/main/zh-Hant-MO/numbers.json",
		1876
	],
	"./zh-Hant/numbers.json": [
		"./node_modules/cldr-data/main/zh-Hant/numbers.json",
		1881
	],
	"./zh/numbers.json": [
		"./node_modules/cldr-data/main/zh/numbers.json",
		1886
	],
	"./zu/numbers.json": [
		"./node_modules/cldr-data/main/zu/numbers.json",
		1891
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./node_modules/cldr-data/main lazy recursive ^\\.\\/.*\\/numbers\\.json$";
module.exports = webpackAsyncContext;